import { z } from 'zod'
import { validators } from './primitives'

export const contactFields = {
  firstName: validators.text.required('First name is required'),
  firstNameOptional: validators.text.optional(),
  lastName: validators.text.required('Last name is required'),
  lastNameOptional: validators.text.optional(),
  email: validators.email.required(),
  emailOptional: validators.email.optional(),
  phone: validators.phone.required(),
  phoneOptional: validators.phone.optional(),
  company: validators.text.optional(),
  companyRequired: validators.text.required('Company name is required'),
  title: validators.text.optional(),
}

export const contactFormSchema = z.object({
  firstName: contactFields.firstName,
  lastName: contactFields.lastNameOptional,
  email: contactFields.email,
  phone: contactFields.phoneOptional,
  company: contactFields.company,
})

export const contactRequiredSchema = z.object({
  firstName: contactFields.firstName,
  lastName: contactFields.lastName,
  email: contactFields.email,
  phone: contactFields.phone,
  company: contactFields.company,
})

export const contactSchema = z.object({
  firstName: contactFields.firstName,
  lastName: contactFields.lastName,
  email: contactFields.email,
  phone: contactFields.phoneOptional,
  company: contactFields.company,
  title: contactFields.title,
})

export const contactPartialSchema = z.object({
  firstName: contactFields.firstNameOptional,
  lastName: contactFields.lastNameOptional,
  email: contactFields.emailOptional,
  phone: contactFields.phoneOptional,
  company: contactFields.company,
  title: contactFields.title,
})

export const contactMinimalSchema = z.object({
  firstName: contactFields.firstName,
  lastName: contactFields.lastNameOptional,
  email: contactFields.email,
})

export const contactWithConsentSchema = contactFormSchema.extend({
  consent: validators.consent,
})

export const contactWithMessageSchema = contactFormSchema.extend({
  message: validators.message.required('Please provide more details'),
})

export type ContactFormValues = z.infer<typeof contactFormSchema>
export type ContactRequiredValues = z.infer<typeof contactRequiredSchema>
export type Contact = z.infer<typeof contactSchema>
export type ContactPartial = z.infer<typeof contactPartialSchema>
export type ContactMinimal = z.infer<typeof contactMinimalSchema>
export type ContactWithConsent = z.infer<typeof contactWithConsentSchema>
export type ContactWithMessage = z.infer<typeof contactWithMessageSchema>

export const contactDefaults = {
  form: {
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    company: '',
  } satisfies ContactFormValues,

  full: {
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    company: '',
    title: '',
  } satisfies Contact,

  partial: {
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    company: '',
    title: '',
  } satisfies ContactPartial,
}
